import { render, staticRenderFns } from "./RequestInfo.vue?vue&type=template&id=f116f5cc&scoped=true"
import script from "./RequestInfo.vue?vue&type=script&lang=js"
export * from "./RequestInfo.vue?vue&type=script&lang=js"
import style0 from "./RequestInfo.vue?vue&type=style&index=0&id=f116f5cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f116f5cc",
  null
  
)

export default component.exports